import React, { createContext, useReducer } from 'react'
import Reducer from './Reducer'
const initialState = {
  loading: false,
  waitingSupportsCount: 0,
  supportRequests: [],
  supportRequestDetail: null,
}
export const storeContext = createContext(initialState)
const StoreContext = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState)
  return <storeContext.Provider value={[state, dispatch]}>{children}</storeContext.Provider>
}
export default StoreContext
